export const VIEWSTEPS = {
  Info: 1,
  Products: 2,
  Success: 3,
};
